import React from 'react';
import { Panel } from 'react-bootstrap';
import './AccessSummaryPanel.css';

export default function AccessSummaryPanel({ 
  user, 
  caps, 
  userCaps, 
  isMobile
}) {
  return (
    <Panel>
      <Panel.Heading style={{ fontSize: isMobile ? '1em' : 'inherit' }}>
        <strong>Camera Summary</strong>
      </Panel.Heading>
      <Panel.Body style={{ fontSize: isMobile ? '0.9em' : 'inherit' }}>
        <p><strong>Admin Access:</strong> {userCaps.filter(uc => uc.userId === user.userId && uc.accessType === 'OWNER').length}</p>
        <p><strong>Full Access:</strong> {userCaps.filter(uc => uc.userId === user.userId && uc.accessType === 'VIEWER').length}</p>
        <p><strong>Live View Only Access:</strong> {userCaps.filter(uc => uc.userId === user.userId && uc.accessType === 'DEMO').length}</p>
        <p><strong>No Access:</strong> {caps.length - userCaps.filter(uc => uc.userId === user.userId).length}</p>
      </Panel.Body>
    </Panel>
  );
} 